import { ItemData } from 'core/models/Template'

export const EXHIBITION_TITLE_KEY = 'exhibitions' as const
export const EXHIBITION_MODULE_KEY = 'instancesCatalog/exhibition' as const

export const EXHIBITION_TABS = ['exhibitionsList', 'exhibitionsPagesList'] as const

export type ExhibitionTab = typeof EXHIBITION_TABS[number]

export const EXHIBITIONS_CATALOG_TYPE = 'exhibitions' as const
export const EXHIBITIONS_PAGES_CATALOG_TYPE = 'exhibitionsPages' as const

export const EXHIBITIONS_CATALOG_CONFIG = {
    type: EXHIBITIONS_CATALOG_TYPE,
    treeView: false,
    additionalData: {},
    fixedHeader: true,
    isExistRightToolbar: false,
    hideHeader: true,
} as const

export const EXHIBITIONS_PAGES_CATALOG_CONFIG = {
    type: EXHIBITIONS_PAGES_CATALOG_TYPE,
    treeView: false,
    additionalData: {},
    fixedHeader: true,
    isExistRightToolbar: false,
    hideHeader: true,
} as const

export type ExhibitionSelectedItems = ItemData[]
